import React from 'react'

const Spinner = ({ type }) => (
  <div className={`spinner ${type}`}>
    <div className="double-bounce1" />
    <div className="double-bounce2" />
  </div>  
)

export default Spinner